// Fade in
(() => {
  const options = {
    root: null,
    threshold: 0.3,
    rootMargin: "0px"
  };

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return;
      }

      // @ts-ignore
      entry.target.dataset.isVisible = "true";

      // Find any siblings that need to be animated in sequence.
      const parent = entry.target.parentElement;

      if (parent) {
        parent.querySelectorAll('.animation--fade-in-sibling').forEach((sibling, index) => {
          setTimeout(() => {
            // @ts-ignore
            sibling.dataset.isVisible = "true";
          }, 600 * (index + 1));
        });
      }

      observer.unobserve(entry.target);
    });
  }, options);

  const triggerElements = document.querySelectorAll('.animation--fade-in');
  triggerElements.forEach(el => observer.observe(el));
})();

// Parallax
(() => {
  const parallaxHeroes = document.querySelectorAll('.hero--parallax');

  if (parallaxHeroes.length === 0) {
    return;
  }

  const parallaxSpeed = 0.3;
  let ticking = false;

  function updateAllParallax() {

    parallaxHeroes.forEach((hero) => {
      const heroImage = hero.querySelector('.hero__image');

      if (heroImage) {
        const rect = hero.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        if (rect.bottom > 0 && rect.top < viewportHeight) {

          const newY = -rect.top * parallaxSpeed;

          heroImage.style.transform = `translateY(${newY}px)`;
        }
      }
    });

    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateAllParallax);
      ticking = true;
    }
  });

  updateAllParallax();
})();